// Icons
import menu from './icons/menu.png';
import back from './icons/back.png';
import logout from './icons/logout.png';
import email from './icons/email.png';
import password from './icons/password.png';
import camera from './icons/camera.png';
import clock from './icons/clock.png';
import date from './icons/date.png';
import defaultPerson from './icons/default-person.png';
import diploma from './icons/diploma.svg';
import exams from './icons/exams.png';
import lessons from './icons/lessons.png';
import live from './icons/live.png';
import next from './icons/next.png';
import play from './icons/play.svg';
import profile from './icons/profile.png';
import settings from './icons/settings.png';
import stackedCoin from './icons/stacked-coin.svg';
import calendar from './icons/calendar.svg';

// Logos
import mainLogo from './logo-no-padding.png';
import purpleLogo from './logo-purple.png';
import whiteLogo from './logo-white.png';
import symbolLogo from './logo-symbol-no-bg.png';

// Images
import banner from './banner.png';
import library from './library.jpg';
import login from './login.png';
import classDefault from './class_default_image.png';

export const ICONS = {
  menu,
  back,
  logout,
  email,
  password,
  camera,
  clock,
  date,
  defaultPerson,
  diploma,
  exams,
  lessons,
  live,
  next,
  play,
  profile,
  settings,
  stackedCoin,
  calendar,
} as const;

// Logos
export const LOGOS = {
  main: mainLogo,
  purple: purpleLogo,
  white: whiteLogo,
  symbol: symbolLogo,
} as const;

// Images
export const IMAGES = {
  banner,
  library,
  login,
  classDefault,
} as const;

// Export all assets as a single object for convenience
export const ASSETS = {
  icons: ICONS,
  logos: LOGOS,
  images: IMAGES,
} as const;
